module.exports = __webpack_public_path__ + "img/class-apply-bn.d6c30363.jpg";